import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BubbleEditorComponent } from './bubble.editor/bubble.editor.component';

const PoolStudioRouting: Routes = [
    // login view
    {
        path: 'poolstudio', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            // handle all other routes
            { path: 'bubbles', component: BubbleEditorComponent},
            { path: '**', component: BubbleEditorComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(PoolStudioRouting)],
    exports: [RouterModule]
})
export class PoolStudioRoutingModule { }
